"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var Experiment = function Experiment(_ref) {
  var experiment = _ref.experiment,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["experiment"]);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      variation = _useState2[0],
      setVariation = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      canRender = _useState4[0],
      setCanRender = _useState4[1];

  (0, _react.useEffect)(function () {
    try {
      var _window, _window$sessionStorag;

      if ((_window = window) !== null && _window !== void 0 && (_window$sessionStorag = _window.sessionStorage) !== null && _window$sessionStorag !== void 0 && _window$sessionStorag.getItem(_constants.DISABLE_EXPERIMENT)) {
        _react["default"].Children.forEach(props.children, function (child) {
          if (child.props.fallback) {
            setVariation(child);
          }
        });

        setCanRender(true);
      } else if (experiment) {
        var activeVariation = null;

        _react["default"].Children.forEach(props.children, function (child) {
          if (activeVariation || ! /*#__PURE__*/_react["default"].isValidElement(child)) {
            return;
          }

          if (child.props.variation && experiment.variation === child.props.variation) {
            activeVariation = child;
          } else if (child.props.fallback && experiment.variation === 'fallback') {
            activeVariation = child;
          }
        });

        setVariation(activeVariation);
        setCanRender(experiment.isReady);
      }
    } catch (e) {
      _react["default"].Children.forEach(props.children, function (child) {
        if (child.props.fallback) {
          setVariation(child);
        }
      });

      setCanRender(true);
    }
  }, [experiment, props.children]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, canRender ? variation : null);
};

Experiment.propTypes = {
  experiment: _propTypes["default"].object,
  children: _propTypes["default"].node.isRequired
};
var _default = Experiment;
exports["default"] = _default;